export const TABLE_ROUTING_NAME_VARIANTS = {
    [`/`]: 'Категории',
    brands: 'Бренды',
    collections: 'Коллекции',
    packs: 'Паки',
    tokens: 'Токены',
    conclutions: 'Выводы',
};
